import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';

export class MyRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  // shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
  //   // Do not reuse if route has guards
  //   // const hasGuards =
  //   //   (future.routeConfig?.canActivate && future.routeConfig.canActivate.length > 0);
  //   //   console.log(future.routeConfig);
  //   //   console.log('navigate');
  //   // return !hasGuards && future.routeConfig === curr.routeConfig;
  //   const hasGuards =
  //     (future.routeConfig?.canActivate?.length ?? 0) > 0 ||
  //     (future.routeConfig?.canLoad?.length ?? 0) > 0;
  //
  //   return !hasGuards && future.routeConfig === curr.routeConfig;
  // }
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Always force re-evaluation for guarded routes
    return false;
  }
}
